import { Raven } from 'init/raven'
import isFunction from 'lodash/isFunction'

/**
 * Максимальная задержка отправки события на ОКО.
 * @type {number}
 */
const OKO_MAX_DELAY = 1000

/**
 * Функция для отправки данных в Oko.
 *
 * @param {*} obj Данные для отправки
 */
export function okoPush (obj) {
  let okoObj = []
  if (typeof oko !== 'undefined') {
    okoObj = oko
  }
  okoObj.push({ ...obj })
}

/**
 * Отправляет в око переданный объект с данными и выполняет колбэк
 * после успешной отправки.
 * @param {Object} obj Объект с данными события.
 * @param {Function} callback Callback при любом ответе.
 * @param {number} [callThroughTimeout] Принудительно вызвать callback через n миллисекунд.
 */
export function awaitPush (obj, callback, callThroughTimeout = OKO_MAX_DELAY) {
  let isCallbackCalled = false

  const prepareCallback = () => {
    if (!isCallbackCalled) {
      isCallbackCalled = true
      callback()
    }
  }
  okoPush(obj)
  document.querySelector('script[src*="oko."]').onload = function () {
    isFunction(callback) && prepareCallback()
  }
  if (callThroughTimeout) {
    setTimeout(() => {
      if (obj.n === 'order') {
        Raven.captureException('OKO order-action FAILED', { extra: obj })
      }
      prepareCallback()
    }, callThroughTimeout)
  }
}

/**
 * Promise для awaitPush
 * @param {Object} obj Объект с данными события.
 * @param {Function} callback Callback при любом ответе.
 * @param {number} [callThroughTimeout] Принудительно вызвать callback через n миллисекунд.
 * @returns {Promise} Promise ответа от API.
 */
export function awaitPushPromise (obj, callback, callThroughTimeout) {
  return new Promise(resolve => {
    OkoHelper.awaitPush(
      obj,
      () => {
        isFunction(callback) && callback()
        resolve()
      },
      callThroughTimeout
    )
  })
}

/**
 * Подписать изменение суммы корзины в oko на изменение корзины.
 * @param {Cart} cart Коллекция корзины.
 */
export function connectCartToOko (cart) {
  if (cart) {
    cart.on('update', OkoHelper.updateOkoInfo)
    OkoHelper.updateOkoInfo(cart)
  }
}

/**
 * Обновить информацию в oko.info.
 * @param {Object} data Коллекция данных.
 */
export function updateOkoInfo (data) {
  const cartSum = data && data.cartInfo && data.cartInfo.sum
  const settlementId = data && data.id
  const okoInfo = window.oko && window.oko.info

  if (typeof cartSum === 'number' && okoInfo) {
    okoInfo['cart-sum'] = cartSum
  }
  if (typeof settlementId === 'number' && okoInfo) {
    okoInfo['settlement-id'] = settlementId
  }
}

/**
 * Возвращает новую функцию, создающую объект с атрибутами.
 * @param {string} categoryName Значение атрибута "data-oko-custom-str".
 * @param {Object} [options] Опции.
 * @param {string} [options.clickHandleAttrName] Заменяющее имя атрибута проверки клика.
 * @returns {Function} Функция, принимающая значение атрибута "data-oko-custom-str" и возвращающая объект со атрибутами.
 */
export function makeClickHandlePropsCreator (
  categoryName = 'unknown',
  { clickHandleAttrName = 'data-oko-event-click' } = {}
) {
  return (customString = '') => ({
    [clickHandleAttrName]: String(true),
    'data-oko-category': categoryName,
    'data-oko-custom-str': customString,
  })
}

const OkoHelper = {
  okoPush,
  awaitPush,
  awaitPushPromise,
  connectCartToOko,
  updateOkoInfo,
  makeClickHandlePropsCreator,
}

export default OkoHelper
